// Module
var code = "<div class=\"Family__subnav\" ng-if=\"Family.patients\"> <sub-nav class=\"hidden-xs\" data-links=\"Family.patients\" data-click-link=\"Family.clickLink\"></sub-nav> <mx-label-value-dropdown class=\"Family__dropdown\" ng-if=\"Family.patients.length > 2\" options=\"Family.patients\" select=\"Family.updateSelectedPatient\" selected-value=\"Family.selectedPatientId\"> </mx-label-value-dropdown> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/activity/family/family.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;